var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq-list" },
    _vm._l(_vm.questions, function(ref, idx) {
      var question = ref.question
      var answer = ref.answer
      return _c("collapse", {
        key: idx,
        ref: "collapse",
        refInFor: true,
        staticClass: "faq-list_item",
        attrs: {
          content: answer,
          "is-collapsed": idx !== _vm.currentIdx,
          title: question
        },
        on: {
          collapse: function($event) {
            return _vm.onCollapse($event, idx)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }